import { Tag } from "../../../../data/models/documentProperties/section";
import { RootState } from "../../../reducers";

export const sectionTagsSelector = (state: RootState): Tag[] =>
  state.currentDocument.document.sectionTags;
